import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PasswordModule } from "primeng/password";
import { ISubscription } from 'rxjs-compat/Subscription';
import { IQueryFormat } from '../enums/types';
import { LoginDialogComponent } from "../login-dialog/login-dialog.component";
import { CurrencyPipe, NgIf, NgOptimizedImage } from "@angular/common";
import { EventS } from '../service/event.s';
import { AddOrderService } from '../service/add-order.service';
import { AuthService } from "../service/auth.service";
import { IUser_P } from "../interfaces/IUser";
import { SocketService } from '../service/socket.service';
import { UserService } from "../service/user.service";
import { NotificationService } from "../service/notification.service";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { TooltipModule } from "primeng/tooltip";
// import { CitiesService } from "../service/cities.service";

declare var bootstrap: any;

@Component({
    selector: 'app-navbar',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, DialogModule, InputTextModule, ReactiveFormsModule, PasswordModule, LoginDialogComponent, NgIf, CheckboxModule, DropdownModule, NgOptimizedImage, CurrencyPipe, TooltipModule],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
    private offcanvasInstance: any;
    visible: boolean = false;
    userForm!: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    cityList: any;
    cartLength: number = 0;
    subscriptions: ISubscription[] = [];

    constructor(private fb: FormBuilder,
                private router: Router,
                // private citiesService: CitiesService,
                public userService: UserService,
                private ns: NotificationService,
                private eventS: EventS,
                private addOrderService: AddOrderService,
                private socketService: SocketService,
                private cd: ChangeDetectorRef,
                public authService: AuthService) {

    }

    async ngOnInit() {
        this.createForm();
        // await this.getCities();

        if (this.authService.gUser?._id) {
            this.eventS.loadAddToCard.subscribe(async (data: boolean) => {
                if (data) await this.loadAddToCardList();
            });

            await this.loadAddToCardList();

            this.subscriptions.push(this.socketService.refreshUserPayment.subscribe(async (data: any) => {
                if (data.mpl_customer_objid) {
                    if (data.type !== 'REFRESH_UI') {
                        this.userService.gUser.next({ action: 'REFRESH_G_USER' });
                    }
                }
                this.cd.detectChanges();
            }));
            this.socketService.getConnection(<any>this.authService.getUserId());
        }
        this.cd.detectChanges();
    }

    // async getCities() {
    //     this.cityList = await this.citiesService.query({ find: { active: true, }, });
    // }

    createForm() {
        this.userForm = this.fb.group({
            usr_companyName_str: ['', Validators.required],
            usr_customerName_str: ['', Validators.required],
            usr_email_str: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
            usr_mobile_number_num: ['', Validators.required],
            usr_userName_str: ['', Validators.required],
            usr_sec_mobile_number_num: [''],
            usr_pass_str: ['', Validators.required],
            usr_cityName_str: ['', Validators.required],
            usr_district_str: ['', Validators.required],
            usr_gstNumber_str: [''],
            usr_state_str: ['', Validators.required],
            usr_pincode_num: ['', Validators.required],
            usr_address_str: ['', Validators.required],
        });
    }

    ngAfterViewInit() {
        const offcanvasEl = document.getElementById('offcanvasNavbar');
        if (offcanvasEl) {
            this.offcanvasInstance = new bootstrap.Offcanvas(offcanvasEl);
        }
    }

    openOffcanvas() {
        this.offcanvasInstance?.show();
    }

    closeOffcanvas() {
        this.offcanvasInstance?.hide();
    }

    ngOnDestroy() {
        if (this.offcanvasInstance) {
            this.offcanvasInstance.hide();
            this.offcanvasInstance.dispose();
        }
        document.querySelectorAll('.offcanvas-backdrop').forEach(el => el.remove());
    }

    async showDialog() {
        // if ( !this.cityList ) {
        //     await this.getCities();
        // }
        this.visible = true;
        let res = <any>await this.userService.getByIdUser(<any>this.authService.gUser._id);
        delete res.usr_pass_str;
        this.userForm.patchValue(res);
    }

    async updateProfile() {
        if (!this.userForm.get('usr_pass_str')?.value) {
            this.ns.showError('Password is required');
            return;
        } else if (this.userForm.invalid) {
            this.ns.showError('Please fill all required fields');
            return;
        }
        let formData: IUser_P = this.userForm.getRawValue();
        if (!formData.usr_pass_str) delete formData.usr_pass_str;
        let res = await this.userService.updateUser(<any>this.authService.gUser._id, formData, { select: '_id' });
        if (res) {
            this.ns.showSuccess('User updated successfully.');
            this.userService.gUser.next({ action: 'REFRESH_G_USER' });
            this.visible = false;
        }
    }

    async loadAddToCardList() {
        if (!this.authService.gUser?._id) return;
        let query = <IQueryFormat>{
            find: <any>{
                active: true,
                user_objid: this.authService.gUser._id
            },
            select: <any>{
                user_objid: 1,
            }
        };
        this.cartLength = await this.addOrderService.count(query);
    }

}
